import {SC_User} from "../SC_User";
import {SC_CrewType} from "../enums/SC_CrewType";
import {SC_CrewBase} from "./SC_CrewBase";

export class SC_EmployeeCrew extends SC_CrewBase {
    constructor({
                    props = {},
                } = {}) {
        super(props);
    }

    static fromAPI(jsonin: Record<string, unknown>): SC_EmployeeCrew {
        return new SC_EmployeeCrew({
            props: SC_CrewBase.basicAPIStuff(jsonin),
        });
    }

    toAPI() {
        return {
            ...super.toAPI()
        };
    }

    clone(): SC_EmployeeCrew {
        const cloned = new SC_EmployeeCrew();
        cloned._clone(this)

        return cloned;
    }

    merge(other: SC_EmployeeCrew): SC_EmployeeCrew {
        this._merge(other);

        return this;
    }

    scavengeUsers(users: SC_User[]): void {
        if (this.leadID) {
            let lead = users.find(user => user.insiteID === this.leadID);
            if (lead)
                this.lead = lead;
        }

        if (this.memberIDs) {
            this.members = this.memberIDs.map(memid => users.find(user => user.insiteID === memid));
        }
    }

    static basicEmpty() {
        return new SC_EmployeeCrew({
            props: {
                internalID: -2,
                active: true,
                crewType: new SC_CrewType(SC_CrewType.EMPLOYEE_BACKED),
                states: [],
                members: [],
        }});
    }

    applyToFormData(formData: FormData, oldValue?: SC_EmployeeCrew) {
        super.applyToFormData(formData, oldValue);

        if (this.leadID !== oldValue?.leadID && this.leadID != null)
            formData.append(SC_CrewBase.inputKeys.leadID, String(this.leadID));
        if (this.memberIDs !== oldValue?.memberIDs && this.memberIDs != null)
            formData.append(SC_CrewBase.inputKeys.members, (this.memberIDs).join(","));
    }
}
